export function initAntiInspect() {
  // Block right-click context menu
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault()
    return false
  })

  // Block keyboard shortcuts for DevTools
  document.addEventListener('keydown', (e) => {
    // F12
    if (e.key === 'F12') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+I (Inspect)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+C (Element picker)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault()
      return false
    }
    // Ctrl+U (View source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
    // Cmd+Option+I (Mac Inspect)
    if (e.metaKey && e.altKey && e.key === 'i') {
      e.preventDefault()
      return false
    }
    // Cmd+Option+J (Mac Console)
    if (e.metaKey && e.altKey && e.key === 'j') {
      e.preventDefault()
      return false
    }
    // Cmd+Option+U (Mac View Source)
    if (e.metaKey && e.altKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
  })

  // Detect DevTools open via debugger statement loop
  const detectDevTools = () => {
    const threshold = 160
    const widthDiff = window.outerWidth - window.innerWidth > threshold
    const heightDiff = window.outerHeight - window.innerHeight > threshold

    if (widthDiff || heightDiff) {
      // DevTools likely open — clear console and show warning
      console.clear()
      console.log(
        '%c⚠️ STOP',
        'color: red; font-size: 60px; font-weight: bold;',
      )
      console.log(
        '%cThis is a private business page. Unauthorized inspection or copying of this code is not permitted.',
        'color: red; font-size: 16px;',
      )
    }
  }

  // Check periodically
  setInterval(detectDevTools, 1000)

  // Disable text selection via CSS (makes copy harder)
  const style = document.createElement('style')
  style.textContent = `
    body {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    input, textarea, select {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `
  document.head.appendChild(style)

  // Disable drag
  document.addEventListener('dragstart', (e) => {
    e.preventDefault()
    return false
  })

  // Clear console on load
  console.clear()
}
